import { type ReactElement } from "react"

import { FileIconTemplate } from "./FileIconTemplate"

interface DocIconProps {
  className?: string
}

export const DOCIcon = ({ className }: DocIconProps): ReactElement => (
  <FileIconTemplate
    className={className}
    text='DOC'
    stripeColor='#2196F3' // Blue
  />
)
